/* src/components/utils/dateUtils.js - Modificado el 04-02-2026 */
/* -----------formato robusto de fecha (DD-MM-AAAA) ----------- */

export const formatFecha = (fecha) => {
  if (!fecha) return "";

  const date = new Date(fecha);
  if (isNaN(date.getTime())) return "";

  const dia = String(date.getDate()).padStart(2, "0");
  const mes = String(date.getMonth() + 1).padStart(2, "0");
  const anio = date.getFullYear();

  return `${dia}-${mes}-${anio}`;
};
